import React from 'react'
import { App, Upload } from 'antd'
import { useSelector } from 'react-redux'
import { UploadProps } from 'antd/lib'
import { useTranslation } from 'react-i18next'
import { AxiosError } from 'axios'
import { useQueryClient } from '@tanstack/react-query'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { createInvestmentImport } from '../service/investmentService'
import { financialStatementsKeys } from '../../financialStatements/queries/financialStatementsQueryKeys'
import { investmentQueryKeys } from '../queries/investmentQueryKeys'

const InvestmentImport = () => {
  const { t } = useTranslation()
  const { notification } = App.useApp()
  const queryClient = useQueryClient()
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario: { id: budgetingScenarioId } = {} } = useSelector(filtersSelector)

  const handleSubmit: UploadProps['customRequest'] = async ({ file }) => {
    try {
      const formData = new FormData()
      formData.append('file', file)

      await createInvestmentImport({ data: formData, companyId, budgetingScenarioId })
      queryClient.invalidateQueries({
        queryKey: investmentQueryKeys.summaries()
      })
      // Invalidate all financial statement report queries (we don't know which accounts were imported)
      queryClient.invalidateQueries({
        queryKey: investmentQueryKeys.reports()
      })
      // Invalidate main financial statements report (to update parent row sums)
      queryClient.invalidateQueries({
        queryKey: financialStatementsKeys.statements()
      })
    } catch (error) {
      if (error instanceof AxiosError) {
        notification.error({
          message: t('message:IMPORT_ERROR'),
          description: t(`error:${error?.response?.data.message}`, t('description:CONTACT_SUPPORT'))
        })
      }
    }
  }

  const props: UploadProps = {
    name: 'file',
    multiple: false,
    accept: '.xlsx',
    showUploadList: false,
    customRequest: handleSubmit
  }

  return <Upload {...props}>{t('investmentsPage:csvImport')}</Upload>
}

export default InvestmentImport
